<template>
  <div class="q-pa-md">
    <div class="q-gutter-y-md">
      <q-card>
        <q-tabs
          v-model="tab"
          dense
          class="text-grey"
          active-color="primary"
          indicator-color="primary"
          align="justify"
          narrow-indicator
        >
          <q-tab name="credentials" icon="login" label="Giris Bilgileri" />
          <q-tab name="smtp" icon="login" label="Mail Hesabi" />
          <q-tab name="mailTemplate" icon="email" label="E-Posta Icerikleri" />
          <q-tab name="sms" icon="login" label="SMS Hesabi" />
          <q-tab name="smsTemplate" icon="sms" label="SMS Icerikleri" />
        </q-tabs>

        <q-separator />

        <q-tab-panels v-model="tab" animated>
          <q-tab-panel name="credentials">
            <Credentials />
          </q-tab-panel>
          <q-tab-panel name="smtp">
            <Smtp />
          </q-tab-panel>
          <q-tab-panel name="mailTemplate">
            <MailTemplate />
          </q-tab-panel>
          <q-tab-panel name="sms">
            <Sms />
          </q-tab-panel>
          <q-tab-panel name="smsTemplate">
            <SmsTemplate />
          </q-tab-panel>
        </q-tab-panels>
      </q-card>
    </div>
  </div>
</template>
<script>
import { ref } from 'vue'
import Credentials from '../components/settings/Credentials.vue'
import Smtp from '../components/settings/Smtp.vue'
import MailTemplate from '../components/settings/MailTemplate.vue'
import Sms from '../components/settings/Sms.vue'
import SmsTemplate from '../components/settings/SmsTemplate.vue'
export default {
  components: {
    Credentials,
    Smtp,
    MailTemplate,
    Sms,
    SmsTemplate,
  },
  setup() {
    const tab = ref('credentials')

    return {
      tab,
    }
  },
}
</script>
